import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
} from "@mui/material";
import React, { useContext, useEffect } from "react";
import { FormProvider, useForm } from "react-hook-form";
// Use native crypto.randomUUID() instead of uuid package to avoid type issues
import HLTextField from "../../../shared/components/Form/HLTextField";
import { hasDirtyFields } from "../../../shared/helpers/hasDirtyFields";
import { ConfigDataContext } from "../../../shared/providers/ConfigDataProvider";
import { SET_CONFIG_DATA } from "../../../shared/reducer";

type TTaskCategoriesDialogProps = {
  id?: string;
  handleCloseDialog: () => void;
};

const TaskCategoriesDialog = ({
  id,
  handleCloseDialog,
}: TTaskCategoriesDialogProps) => {
  // Load context
  const configData = useContext(ConfigDataContext);

  // Retrieve TaskConfigData[], correctly typed
  const data = configData.state?.data as any[];

  // Helper
  const isEditing = !!id;

  // Find current TaskConfigData (if editing)
  const defaultValues = isEditing
    ? data?.find((taskConfig) => taskConfig.id === id)
    : { text: "" };

  // Intiate RHF
  const methods = useForm({
    mode: "all",
    defaultValues,
  });
  const {
    formState: { isSubmitSuccessful },
  } = methods;

  // Bypass memory leak cause by not consitently mounting dialog
  useEffect(() => {
    if (!isSubmitSuccessful) return;
    handleCloseDialog();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isSubmitSuccessful]);

  const handleSubmit = (formData: any) => {
    // Updated/new TaskConfigData
    const newTaskConfig = {
      id: isEditing ? id : crypto.randomUUID(), // editing ?? new task category
      ...formData,
    };

    // Updated/new TaskConfigData[]
    const newData = isEditing
      ? data?.map((taskConfig) =>
          taskConfig.id === id ? newTaskConfig : taskConfig
        )
      : [...data, newTaskConfig];

    // Spread loaded configData (id, publicAccess) w/ new TaskConfigData[]
    const payload = {
      ...configData.state,
      data: newData,
    };

    // Mutate configData
    configData.dispatch({
      type: SET_CONFIG_DATA,
      payload,
    });
  };

  return (
    <Dialog open onClose={handleCloseDialog}>
      <FormProvider {...methods}>
        <form onSubmit={methods.handleSubmit(handleSubmit)}>
          <DialogContent>
            <HLTextField name="text" label="Aufgabentyp" margin="normal" />
          </DialogContent>
          <DialogActions>
            <Button onClick={handleCloseDialog} color="primary">
              Abbrechen
            </Button>
            <Button
              type="submit"
              color="primary"
              disabled={!hasDirtyFields(methods)}
            >
              Speichern
            </Button>
          </DialogActions>
        </form>
      </FormProvider>
    </Dialog>
  );
};

export default TaskCategoriesDialog;
